export const VERDICT_TOOLTIPS = {
  incorrect: 'The marked correct answer does not match what the section text supports.',
  invalid: 'The question cannot be answered correctly using only the section text.',
  vague: 'The question or answer options are ambiguous or unclear.',
  valid: 'The question can be correctly answered using the section text.',
};

export const VERDICT_STYLES = {
  incorrect: 'tw-bg-orange tw-bg-opacity-20 tw-text-orange tw-border-orange tw-border-opacity-50',
  invalid: 'tw-bg-red tw-bg-opacity-20 tw-text-red tw-border-red tw-border-opacity-50',
  vague: 'tw-bg-tci-purple tw-bg-opacity-20 tw-text-tci-purple tw-border-tci-purple tw-border-opacity-50',
  valid: 'tw-bg-green tw-bg-opacity-20 tw-text-green tw-border-green tw-border-opacity-50',
};

export const HAS_IMAGE_STYLE = 'tw-bg-blue tw-bg-opacity-10 tw-text-blue tw-border-blue tw-border-opacity-50';

export const VARIANT_STYLES = {
  incorrect: 'tw-bg-orange tw-bg-opacity-10 tw-border-orange tw-border-opacity-50',
  invalid: 'tw-bg-red tw-bg-opacity-10 tw-border-red tw-border-opacity-50',
  vague: 'tw-bg-tci-purple tw-bg-opacity-10 tw-border-tci-purple tw-border-opacity-50',
  valid: 'tw-bg-green tw-bg-opacity-10 tw-border-green tw-border-opacity-50',
};

export const formatDate = (isoString?: string) => {
  if (!isoString) return '';

  return new Date(isoString).toLocaleString('en-US');
};
